<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-bar :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<mapping-table :scrId="scrId" />
			</div>
		</div>
	</div>
</template>

<script>
import { SearchBar } from './Search';
import { MappingTable } from './Table';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchBar,
		MappingTable
	}
};
</script>

<style></style>
